import { render, staticRenderFns } from "./defaultTemplate.vue?vue&type=template&id=08c4d080&scoped=true"
import script from "./defaultTemplate.vue?vue&type=script&lang=js"
export * from "./defaultTemplate.vue?vue&type=script&lang=js"
import style0 from "./defaultTemplate.vue?vue&type=style&index=0&id=08c4d080&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c4d080",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08c4d080')) {
      api.createRecord('08c4d080', component.options)
    } else {
      api.reload('08c4d080', component.options)
    }
    module.hot.accept("./defaultTemplate.vue?vue&type=template&id=08c4d080&scoped=true", function () {
      api.rerender('08c4d080', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PaymentCallback/components/defaultTemplate.vue"
export default component.exports